import { isAuthorizedToEditUser } from '@core/utils/role.utils'
import { createFileRoute, redirect } from '@tanstack/react-router'

import { userDetailsQuery } from '@/queries/user.query'

export const Route = createFileRoute('/_dashboard/users/edit/$userId/')({
  async beforeLoad({ context, params: { userId } }) {
    const currentUserRole = context.user?.role
    const userToEdit = await context.queryClient.ensureQueryData(userDetailsQuery(userId))

    if (!isAuthorizedToEditUser(currentUserRole, userToEdit.role)) {
      throw redirect({
        to: '/403',
      })
    }
  },
})
